import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import "./magzine.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import {
  deleteVideo,
  //   getVideos,
  postVideoUpdate,
} from "../../../store/Action/videoAction";
import axios from "axios";
import { deleteMagzine } from "../../../store/Action/magzineAction";
import Pagination from "../../../Pagination";
function ManageMagzine() {
  const dispatch = useDispatch();
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const [videos, setVideos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage,setTotalPage]= useState('');

  const [deletes, setDelete] = useState(1);
  const itemsPerPage = 12; // Change this to the desired number of items per page

  // Logic to calculate total pages
  // const queryParams = { page: currentPage, perPage: itemsPerPage };

  // Fetch categories and total count from API or any data source
  useEffect(() => {
    const fetchMagzine = async () => {
      try {
        const response = await axios.get(`${apiUrl}magzine`);
        if (response) {
          // console.log(response, "videossssss");
          setVideos(response.data); // Update with the correct field name from your API response
          // console.log(response.data, videos, "video");
        }
      } catch (error) {
        console.error("Error fetching videos:", error);
      }
    };

    fetchMagzine();
  }, [dispatch, currentPage, deletes]);
  
  // const fetchMagzine = async (page, perPage) => {
  //   try {
  //     const response = await axios.get(`${apiUrl}magzine`, {
  //       params: { page, limit: perPage },
  //     });

  //     if (response.data) {
  //       console.log(response.data, 'magazines');
  //       setMagazines(response.data.data); // Update with the correct field name from your API response
  //       setTotalPages(response.data.totalPages);
  //       setTotalItems(response.data.totalItems);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching magazines:', error);
  //   }
  // };

  // useEffect(() => {
  //   fetchMagzine(currentPage, itemsPerPage);
  // }, [currentPage, itemsPerPage]);


  // console.log(videos, "poiy");
  // Logic to handle pagination controls
  const nextPage = () => {
    if (videos.length === itemsPerPage) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const handleDelete = (categoryId) => {
    if (window.confirm("Are you sure you want to delete this category?")) {
      const response = dispatch(deleteMagzine(categoryId));
      if (response) {
        setDelete(response);
      }
    }
  };
  return (
    <div className="manage-category">
      <div className="card">
        <div className="card-header">Manage Magzine</div>
        <div className="card-body">
          <table className="table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Magzine Issue Date</th>
                <th scope="col">year</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {videos.map((video) => (
                <tr key={video._id}>
                  <td>{video.issueDate}</td>
                  <td>{video.year}</td>
                  <td>
                    <Link to={`/editmagzine/${video._id}`}>
                      <button className="action-button">
                        <FontAwesomeIcon icon={faEdit} />
                      </button>
                    </Link>

                    <button
                      className="action-button"
                      onClick={() => handleDelete(video._id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="card-footer bg-transparent border-secondary d-flex justify-content-center">
            <div className="pagination">
              <button
                className="pagination-btn"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                Previous
              </button>
              <span className="current-page">{currentPage}</span>

              <button
                className="pagination-btn"
                onClick={nextPage}
                disabled={videos.length < itemsPerPage}
              >
                {videos.length < itemsPerPage ? "" : "Next"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageMagzine;
